module.exports = __webpack_public_path__ + "static/media/arrowcurcle.47828c10.svg";